"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactI18next = require("react-i18next");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _lodash = require("lodash");
var _clsx = _interopRequireDefault(require("clsx"));
var _actionsheetReact = _interopRequireDefault(require("actionsheet-react"));
var _checkIsTouch = _interopRequireDefault(require("../../utils/checkIsTouch"));
var _sociallinks = _interopRequireDefault(require("../sociallinks"));
var _appContext = _interopRequireDefault(require("../../context/appContext"));
var _pageContext = _interopRequireDefault(require("../../context/pageContext"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  content: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
    maxWidth: 650,
    padding: theme.spacing(6, 2)
  },
  label: {
    margin: theme.spacing(2, 0, 0)
  },
  number: {
    color: theme.palette.foreground.contact.label,
    fontSize: 26,
    fontWeight: 700
  },
  button: {
    margin: theme.spacing(2.5, 0, 0)
  },
  socialMedia: {
    background: theme.palette.background.drawer
  },
  socialMediaWrapper: {
    alignItems: "center",
    background: theme.palette.background.drawer,
    display: "flex",
    justifyContent: "space-between",
    margin: "0 auto",
    maxWidth: 650,
    padding: theme.spacing(3.5, 2)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(2),
    top: theme.spacing(2)
  },
  fabButton: {
    bottom: "calc(env(safe-area-inset-bottom) + 75px + ".concat(theme.spacing(2), "px)"),
    opacity: 0,
    position: "fixed",
    right: theme.spacing(2),
    transition: theme.transitions.create(["opacity"]),
    zIndex: theme.zIndex.fabButton,
    [theme.breakpoints.up("sm")]: {
      bottom: "calc(75px + ".concat(theme.spacing(3), "px)"),
      right: theme.spacing(3)
    }
  },
  fabButtonInFooter: {
    bottom: "calc(env(safe-area-inset-bottom) + 13px)",
    opacity: 1,
    right: theme.spacing(1),
    zIndex: theme.zIndex.fabButtonInFooter
  }
}));
const ContactOverlay = _ref => {
  var _theme$palette;
  let {
    fabButtonRef
  } = _ref;
  const {
    REACT_APP_MAINNAV,
    REACT_APP_FAB_BUTTON_IN_FOOTER
  } = process.env;
  const [appData] = (0, _react.useContext)(_appContext.default);
  const [pageData] = (0, _react.useContext)(_pageContext.default);
  const {
    menuGroups
  } = pageData.data;
  const ref = (0, _react.useRef)();
  const theme = (0, _styles.useTheme)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const history = (0, _reactRouterDom.useHistory)();
  const css = useStyles();
  const isTouch = (0, _checkIsTouch.default)();
  const handleOpen = () => {
    ref.current.open();
  };
  const handleClose = () => {
    ref.current.close();
  };
  const menuGroup = (0, _lodash.find)(menuGroups, function (o) {
    return o.title === REACT_APP_MAINNAV;
  });
  const menu = (0, _lodash.find)(menuGroup === null || menuGroup === void 0 ? void 0 : menuGroup.items, function (o) {
    var _o$icon;
    return (o === null || o === void 0 || (_o$icon = o.icon) === null || _o$icon === void 0 ? void 0 : _o$icon.filename) === "/img/icons/phone.svg";
  });
  const handleClick = () => {
    var _menu$link;
    history.push((_menu$link = menu === null || menu === void 0 ? void 0 : menu.link) !== null && _menu$link !== void 0 ? _menu$link : "tel:".concat(appData === null || appData === void 0 ? void 0 : appData.phone));
    handleClose();
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isTouch && /*#__PURE__*/_react.default.createElement(_core.Fab, {
    ref: fabButtonRef,
    className: (0, _clsx.default)({
      [css.fabButton]: true,
      [css.fabButtonInFooter]: REACT_APP_FAB_BUTTON_IN_FOOTER
    }),
    color: "primary",
    size: "medium",
    onClick: handleOpen
  }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    src: "/img/icons/phone.svg",
    size: 26
  })), /*#__PURE__*/_react.default.createElement(_actionsheetReact.default, {
    ref: ref,
    zIndex: 2000,
    sheetStyle: {
      backgroundColor: theme === null || theme === void 0 || (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.background) === null || _theme$palette === void 0 ? void 0 : _theme$palette.contactOverlay,
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20
    },
    bgStyle: {
      backgroundColor: "rgba(0, 0, 0, 0.5)"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.content
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: css.closeButton,
    onClick: handleClose
  }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    src: "/img/icons/close.svg",
    size: 24
  })), /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    src: "/img/icons/hotline.svg",
    size: 65
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.label,
    component: "p"
  }, t("site.ui.labels.hotline")), /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:".concat(appData === null || appData === void 0 ? void 0 : appData.phone)
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.number,
    component: "span"
  }, appData === null || appData === void 0 ? void 0 : appData.phone)), /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: css.button,
    color: "primary",
    component: "a",
    variant: "contained",
    size: "medium",
    onClick: handleClick
  }, t("site.ui.buttons.call"))), /*#__PURE__*/_react.default.createElement("div", {
    className: css.socialMedia
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.socialMediaWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.socialMediaHeadline,
    variant: "subtitle1"
  }, t("site.ui.labels.connectNow")), /*#__PURE__*/_react.default.createElement(_sociallinks.default, null)))));
};
var _default = exports.default = ContactOverlay;